import { render, staticRenderFns } from "./NavItemSlide.vue?vue&type=template&id=f0b275c4&scoped=true&"
import script from "./NavItemSlide.vue?vue&type=script&lang=js&"
export * from "./NavItemSlide.vue?vue&type=script&lang=js&"
import style0 from "./NavItemSlide.vue?vue&type=style&index=0&id=f0b275c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b275c4",
  null
  
)

export default component.exports